module.exports = __webpack_public_path__ + "media/images/features/5/main/main-3-83858110c32387c9f3e746157ad01cff.jpg";